import React, { useState } from "react";
import DataTable from 'datatables.net';
import $ from "jquery"
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";

export default function UserAdministrationdetails() {

    const [usename, setusername] = useState<string>("")

    if ($.fn.dataTable.isDataTable('#userdata')) {
        $('#userdata').DataTable();
    }
    else {
        $('#userdata').DataTable({
            ordering: false
        });
    }

    function searchuser() {

        var filter, table, td, i, txtValue;
        filter = usename.toUpperCase();

        table = document.getElementById("userdata");
        const tr = table?.getElementsByTagName("tr")

        if (tr !== undefined) {
            for (i = 0; i < tr.length; i++) {
                td = tr[i].getElementsByTagName("td")[1];

                if (td) {
                    txtValue = td.textContent || td.innerText;
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        tr[i].style.display = "";
                    } else {
                        tr[i].style.display = "none";
                    }
                }
            }
        }
    }


    return (
        <>

            {/* UserAdministrationdetails start */}

            <div className="usersdministrationdetails_Details">
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div className="d-flex">
                        <div>
                            <div className="createaccountpage_content_header">
                                User Administration
                            </div>
                            <div className="createaccountpage_content_text">
                                Manage your team members role
                            </div>
                        </div>
                        <div>
                            <button type="button" className="createaccountpage_edit_button">
                                Add User
                            </button>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_content_user_table_container">
                    <div className="search_data_table">
                        <input type="text" name="searchuser" id="searchuser" placeholder="Search a user" className="search_data_table_input" onChange={(e) => setusername(e.target.value)}></input>
                        <div className="search_data_table_icon" onClick={() => searchuser()}>
                            <img src="/assets/images/search.png" alt="search" />
                        </div>
                    </div>
                    <table className="createaccountpage_content_user_table" id="userdata">
                        <thead>
                            <tr>
                                <th className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </th>
                                <th>User</th>
                                <th>Role</th>
                                <th>Last Login</th>
                                <th>Joined Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-1.png" alt="user-one" />
                                    <div>
                                        <span>Paula Theresia</span>
                                        <span>paula.theresia@gmail.com</span>
                                    </div>
                                </td>
                                <td>Administrator</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-2.png" alt="user-two" />
                                    <div>
                                        <span>Daniel Tomasson</span>
                                        <span>daniel.tomasson@gmail.com</span>
                                    </div>
                                </td>
                                <td>Analyst</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-3.png" alt="user-three" />
                                    <div>
                                        <span>Alexander Olsen</span>
                                        <span>alex.olsen@gmail.com</span>
                                    </div>
                                </td>
                                <td>Supervisor</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-4.png" alt="user-four" />
                                    <div>
                                        <span>David Rodrigo</span>
                                        <span>d.rodrigo@gmail.com</span>
                                    </div>
                                </td>
                                <td>E-Commerce</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-5.png" alt="user-five" />
                                    <div>
                                        <span>Stevan Karagounis</span>
                                        <span>karagounis.stevan@gmail.com</span>
                                    </div>
                                </td>
                                <td>Support</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className="select_checkbox">
                                    <input className="form-check-input" type="checkbox" id="check1" name="option1" value="something" />
                                </td>
                                <td className="d-flex">
                                    <img src="/assets/images/user-6.png" alt="user-six" />
                                    <div>
                                        <span>Wright Frederick</span>
                                        <span>wright.fred@gmail.com</span>
                                    </div>
                                </td>
                                <td>Support</td>
                                <td>25 days ago</td>
                                <td>21 October 2022, 10.45PM</td>
                                <td className="dropdown">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                                        Action
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><button className="dropdown-item" type="button">Edit</button></li>
                                        <li><button className="dropdown-item" type="button">Delete</button></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* UserAdministrationdetails over */}

        </>
    )

}